module.exports = __webpack_public_path__ + "static/media/ic_calendar.47512497.svg";